export enum CountryCode {
  Austria = "AT",
  Belgium = "BE",
  CzechRepublic = "CZ",
  Denmark = "DK",
  France = "FR",
  Germany = "DE",
  Italy = "IT",
  Liechtenstein = "LI",
  Luxembourg = "LU",
  Netherlands = "NL",
  Poland = "PL",
  Switzerland = "CH",
}

const countryCodeSet = new Set(Object.values(CountryCode));

export const mapToCountryCode = (countryCode: string): CountryCode => {
  const normalizedCountryCode = countryCode.trim().toUpperCase();

  if (countryCodeSet.has(normalizedCountryCode as CountryCode)) {
    return normalizedCountryCode as CountryCode;
  }

  // eslint-disable-next-line no-console
  console.error(
    `[mapToCountryCode] Unknown countryCode '${countryCode}', fallback to '${CountryCode.Germany}'.`,
  );

  return CountryCode.Germany;
};
